import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import store from "./store/store";
import { GLOBALS } from "./helpers";
import "./scss/styles.scss";

// Vue Components
/* eslint-disable no-unused-vars */
import bodyComponent from "./components/body-component.vue";
/* eslint-enable no-unused-vars */

Vue.config.devtools = true;

// Vue App
const app = new Vue({
  // eslint-disable-line no-unused-vars
  el: "#calendar-app",
  components: {
    "body-component": bodyComponent
  },
  store,
  computed: {
    ...mapGetters({
      isLoading: "getLoading",
      userLoad: "getUser",
      labels: "getLabels"
      // promoContent: "getPromoContent",
      // bannerContent: "getBannerContent",
      // labelsFile: "getLabelsFile"
    })
  },
  methods: {
    ...mapActions(["updateLabels", "updateLoading", "updateTestingVariables"]),
    // loadLabels() {
    //   return new Promise(resolve => {
    //     axios
    //       .get(this.labelsFile)
    //       .then(response => {
    //         this.updateLabels(response.data[0]).then(() => {
    //           resolve();
    //         });
    //       })
    //       .catch(error => {
    //         console.log(error.message);

    //         console.error(error);
    //       });
    //   });
    // },
    getTestingVariables() {
      const date = GLOBALS.getUrlParameterByName("date");
      const targetGroupId = GLOBALS.getUrlParameterByName("targetGroupId");
      const responseCode = GLOBALS.getUrlParameterByName("responseCode");
      this.updateTestingVariables({ date, targetGroupId, responseCode });
    }
  },
  mounted() {
    const self = this;
    this.getTestingVariables();
    this.updateLoading(false);
    // if (!this.labels) {
    //   this.loadLabels().then(() => {
    //     self.updateLoading(false);
    //   });
    // }
  }
});



// WEBPACK FOOTER //
// ./src/main.js